import { useSelector } from "react-redux";
import { RootState } from "store";

// True when shipping and label actions should be blocked for the current
// sales account: the account is on stop, or its status is anything other
// than active ("A"). The on-stop banner in LayoutAuthenticated deliberately
// stays keyed to on-stop only.
export const useIsAccountRestricted = (): boolean => {
  const { alertType, accountStatus } = useSelector((state: RootState) => {
    return state.authSlice;
  });

  return alertType === "onstop" || (!!accountStatus && accountStatus !== "A");
};
